module.exports = __webpack_public_path__ + "static/media/gem.4990b997.svg";